/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { isFunction } from 'lodash';

export function aspectAround(fn: ((...args: any[]) => any) | object,
                             name: string,
                             around: (source: (...args: any[]) => any) => (...args: any[]) => any): void {
  if (isFunction(fn)) {
    const original = fn.prototype[name];

    fn.prototype[name] = around(original);
  } else {
    const original = fn[name];
    fn[name] = around(original);
  }
}
